import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatDialogRef, MatDividerModule, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { SessionStorageService } from '../../core/sessionstorage.service';
import { Response } from '@angular/http';
import { PageContent } from '../../core/index.model';
import { PageContentService } from '../../core/index.service';

@Component({
  selector: 'app-pdfmessage',
  templateUrl: './pdfmessage.component.html',
  styleUrls: ['./pdfmessage.component.css']
})
export class PDFMessageComponent implements OnInit {
    RefNo: string = '';
    formtype: string = '';
    WarningMsg: string = '';
    isError: string = '';

    @Input() pageContent: PageContent;

    constructor(
        private router: Router,
        public dialogRef: MatDialogRef<PDFMessageComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public storageService: SessionStorageService,
        private pcService: PageContentService,
    ) { }

    ngOnInit() {
        if (this.data["RefID"] != null && this.data["RefID"] != '' && this.data["RefID"] != 0) {
            this.RefNo = this.data["RefID"]; 
            this.WarningMsg = "Successful";
        } else {
            this.WarningMsg = "Failed";
            this.isError = this.data['Error'];
        }
    }    

    close(): void {        
        this.dialogRef.close();
        this.router.navigateByUrl('/home');
    }

    retryPDF() {
        this.dialogRef.close();
    }

    getColor() {
        return this.WarningMsg === 'Successful' ? 'green' : 'red';
    }
}



// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/common/pdfmessage.component.ts